import './reviewCard.scss';
import { FaFacebook, FaGoogle, FaInstagram, FaTiktok, FaTripadvisor } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import ownLogo from '../../images/logo.svg';
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';
import { useState, useRef, useEffect } from "react";

const ReviewCard = ({ review }) => {
    const [expanded, setExpanded] = useState(false);
    const [isTruncated, setIsTruncated] = useState(false);
    const textRef = useRef(null);

    const renderStars = (rating) => {
        const stars = [];
        const full = Math.floor(rating);
        const half = rating % 1 !== 0;

        for (let i = 0; i < full; i++) stars.push(<FaStar key={i} />);
        if (half) stars.push(<FaStarHalfAlt key="half" />);
        while (stars.length < 5) stars.push(<FaRegStar key={stars.length} />);

        return stars;
    };

    // Detect if text exceeds 9 lines
    useEffect(() => {
        const el = textRef.current;
        if (!el) return;

        const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
        const maxHeight = lineHeight * 9;

        if (el.scrollHeight > maxHeight) {
            setIsTruncated(true);
        }
    }, []);

    return (
        <div className="reviewCard fadeIn">

            <div className="customerInfo">
                <div className="info">

                    {/* GOLD VERIFIED BORDER WRAPPER */}
                    <div className={`avatarWrapper ${review.verified ? "verifiedBorder" : ""}`}>

                        {review.avatar && review.avatar !== "none" ? (
                            <div className="imageHolder">
                                <img src={`${process.env.REACT_APP_API_URL}/avatar/${review.avatar}`} alt={review.customerName} />
                            </div>
                        ) : (
                            <div className="initials">
                                {review.customerName
                                    ?.split(" ")
                                    .map((word) => word[0])
                                    .join("")
                                    .toUpperCase()}
                            </div>
                        )}

                    </div>

                    <h2>{review.customerName}</h2>
                </div>

                <span className={review.verified ? "verified" : "unverified"}>
                    {review.verified ? "Verified" : "Unverified"}
                </span>
            </div>

            <div className="reviewStars">{renderStars(review.rating)}</div>

            <div ref={textRef}
                className={`reviewText ${expanded ? "expanded" : "clamped"}`}
            >
                “{review.comments}”
            </div>
            {isTruncated && (
                <button
                    className="toggleMore"
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded ? "Read less ▲" : "Read more ▼"}
                </button>
            )}

            <div className="reviewSource">
                <div className={`sourceIcon ${review.testimonySource === "Google" ? "google" :
                        review.testimonySource === "Trip Advisor" ? "trip" :
                            review.testimonySource === "Facebook" ? "facebook" :
                                review.testimonySource === "Tik Talk" ? "tiktok" :
                                    review.testimonySource === "Instagram" ? "instagram" :
                                        review.testimonySource === "Shisha" ? "shisha" : ""
                    }`}>

                    {review.testimonySource === "Google" ? (
                        <FaGoogle className="icon google" />
                    ) : review.testimonySource === "Trip Advisor" ? (
                        <FaTripadvisor className="icon trip" />
                    ) : review.testimonySource === "Shisha" ? (
                        <img src={ownLogo} alt="Oldkent Shisha Logo" />
                    ) : review.testimonySource === "Facebook" ? (
                        <FaFacebook className='icon facebook' />
                    ) : review.testimonySource === "Tik Talk" ? (
                        <FaTiktok className='icon tiktok' />
                    ) : review.testimonySource === "Instagram" ? (
                        <FaInstagram className='icon instagram' />
                    ) : ""}
                </div>

                <Link to={review.readOn}>
                    Read on <span>{review.testimonySource}</span>
                </Link>
            </div>
        </div>
    );
};

export default ReviewCard;
